import { Box, SxProps, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { OpenQuestionOutcome } from 'services/conversations/types';
import { BoxedLabel } from './BoxedLabel';
import { isNumber } from 'utils/validation';

const container: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1
};

type Props = {
  openQuestionOutcome: OpenQuestionOutcome;
};

const OpenEndedQuestionsOutcome: React.FC<Props> = ({
  openQuestionOutcome
}) => {
  const scoreCalculation = useMemo(() => {
    const count = openQuestionOutcome.openQuestionRequirementOutcomes?.length;
    if (isNumber(openQuestionOutcome.score) && isNumber(count)) {
      return `${openQuestionOutcome.score}/${count}`;
    }
    if (isNumber(openQuestionOutcome.score)) {
      return 'Score pending';
    }
    return 'No score';
  }, [
    openQuestionOutcome.score,
    openQuestionOutcome.openQuestionRequirementOutcomes
  ]);

  return (
    <Box sx={container}>
      <Typography fontWeight="bold">
        Q: {openQuestionOutcome.question}
      </Typography>
      <Typography>A: {openQuestionOutcome.responseSummary}</Typography>
      <BoxedLabel
        containerProps={{ placeSelf: 'end' }}
        value={scoreCalculation}
      />
    </Box>
  );
};

export { OpenEndedQuestionsOutcome };
